import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SharedModule } from '../../shared-module';
import { map, Observable, of } from 'rxjs';
import { FilterByKeyPipe } from '../../../feature-module/core/pipes/filter-by-key.pipe';

declare var bootstrap:any;

@Component({
  selector: 'app-select',
  imports: [CommonModule, SharedModule, FilterByKeyPipe],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [
   {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements AfterViewInit, ControlValueAccessor {

  @ViewChild('dropDown') dropDown!: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  @Input() formControlName!: string;
  @Input() parentFormGroup?: any;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() options: any[] = [];

  filterOptions$: Observable<any[]> = of([]);
  searchText: string = '';

  value: any;

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
     private readonly controlContainer: ControlContainer,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.dropDown && this.dropdownMenu) {
        const width = this.dropDown.nativeElement.offsetWidth;
        this.dropdownMenu.nativeElement.style.width = `${width}px`;
      }
      if(!this.options || this.options.length === 0) {
        this.filterOptions$ = of([]);
        return;
      }
      this.filterOptions$ =  of(this.options);
    },);
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.value = selectElement.value;
    this.onChange(this.value);
    this.onTouched();
  }

  get control() {
    if(!this.parentFormGroup) {
      return this.controlContainer?.control?.get(this.formControlName);
    }

    const ctrl = this.parentFormGroup.get(this.formControlName);
    return ctrl;
  }

  onBlur() {
    this.onTouched();
    if(!this.searchText) {
      return
    }

    const stream = of(this.options);
    if (!stream) {
      this.value = null;
      this.onChange(null);
      this.searchText = '';
      return;
    }
    stream.subscribe(options => {
      const findOption = options.find(option => option.label.toLowerCase() === this.searchText.toLowerCase());
      if (findOption) {
        this.value = findOption.code;
        this.onChange(findOption.code);
      } else {
        this.value = null;
        this.onChange(null);
        this.searchText = '';
      }
    });
  }

  search(value: string): void {
    if (!value) {
      this.filterOptions$ = of(this.options);
      return;
    }

    const stream = of(this.options);
    if (!stream) {
      this.filterOptions$ = of([]);
      return;
    }
    this.filterOptions$ = stream.pipe(
      map(options => options.filter(option =>
        option.label.toLowerCase().includes(value.toLowerCase())
      ))
    );
  }

  setValue(value: any, locator: HTMLDivElement) {
    this.value = value.code;
    this.searchText = value.label;
    this.onChange(value.code);
    this.onTouched();
    this.closeDropDown(locator);
  }

  private closeDropDown(locator: HTMLDivElement) {
    const dropdown = bootstrap.Dropdown.getInstance(locator);
    dropdown?.hide();
  }


}
